// extracted by mini-css-extract-plugin
export default {"title":"Q5rfv","subtitle":"I93NQ","title-block":"_TrxJ","collection-wrapper":"EnsEV"};